<template>
    <div>
        <k-select
            v-if="!addingNew"
            :label="label"
            :placeholder="placeholder"
            v-model="model"
            :options="options"
            :show-selected-options="showSelectedOptions"
            :multiple="multiple"
            :required="required"
            :allow-search="allowSearch"
            :show-tags="showTags"
            :auto-close="autoClose"
            :disabled="disabled"
            :show-inputs-inline="true"
            :server-side-search="true"
            v-on:search="loadData"
            :error="error"
            v-on:reset-error="$emit('reset-error')">
            <template v-slot:header>
                <div v-if="allowNew" class="dropdown-item title d-flex align-items-center gap-2" role="button"
                     @click="addingNew = true">
                    <i class="fi fi-rr-plus"></i>
                    {{ trans('general.defaults.add_new') }}
                </div>
            </template>
        </k-select>

        <add-setting-quick-form
            v-if="addingNew"
            class="addNew"
            :type="type"
            v-on:save="addNewSetting"
            v-on:close="addingNew = false"/>
    </div>
</template>

<script>
import KSelect from "../molecules/KSelect.vue";
import AddSettingQuickForm from "../molecules/AddSettingQuickForm.vue";

export default {
    name: "SettingSelect",
    props: {
        value: Object | String,
        type: String,
        label: String,
        placeholder: String,
        multiple: {
            type: Boolean,
            default: false
        },
        showSelectedOptions: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: true
        },
        autoClose: {
            type: String,
            default: 'true'
        },
        allowSearch: {
            type: Boolean,
            default: true
        },
        showTags: {
            type: Number,
            default: 0
        },
        disabled: Boolean,
        allowNew: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            required: false,
        },
    },
    components: {
        AddSettingQuickForm,
        KSelect
    },
    watch: {
        model: function (val) {
            this.$emit('change', val)
            this.$emit('input', val)
        },
        value: function (val) {
            this.model = val;
        },
        addingNew: function (val) {
            this.$emit('adding-new', val)
        }
    },
    data() {
        return {
            mode: 'activity',
            observer: null,
            model: [],
            options: [],
            addingNew: false,
        }
    },
    methods: {
        setModel(model) {
            this.model = model
        },
        loadData(search = '') {
            axios.get(`/settings/${this.mode}`, {
                params: {
                    limit: 15,
                    search: search,
                    search_fields: 'label:like'
                }
            }).then(response => {
                this.options = response.data.data.data.map(item => {
                    return {id: item.id, label: item.label, data: item}
                });
            });
        },

        addNewSetting(setting) {
            this.addingNew = false;
            const newSetting = {id: setting.id, label: setting.label, data: setting};
            this.options = [newSetting, ...this.options];
            if(this.multiple) {
                this.model = [newSetting, ...this.model];
            } else {
                this.model = [newSetting];
            }
        }
    },
    mounted() {
        this.mode = this.type || this.mode;
        if (this.value) { this.setModel(this.value) }
        this.loadData();
    }
}
</script>
